

import Price from "../../../common/components/ob1/Price.vue";
import {PropType} from "vue";
import {OfferPriceDetailsDto, PriceDetailsCashbackType} from "../../components/custom/models/PriceDetailsPopinDto";
import {PromotionType} from "../../components/ob1/models/Price";
import {computeCashbackType, computeDiscountType, computeFinalDiscountType} from "../../utils/PriceDetailsPromotion";
import CardContentSeparator from "../../../showcase/components/CardContentSeparator.vue";

export default {
    name: "PriceDetailsContent",
    components: {
        CardContentSeparator,
        Price,
    },
    props: {
        id: {
            type: String,
            required: true,
        },
        index: {
            type: Number,
            required: true,
        },
        offerPriceDetails: {
            type: Object as PropType<OfferPriceDetailsDto>,
            required: true,
        },
    },
    data() {
      return {
          PROMO_DURATION: PromotionType.PROMO_DURATION,
          END_OF_PROMO: PromotionType.END_OF_PROMO,
      }
    },
    computed: {
        tileFinalPrice(): number {
            return this.offerPriceDetails.finalDiscountedPrice;
        },
        tileFinalPricePermanent(): number {
            return this.offerPriceDetails.finalPermanentPrice;
        },
        tileDuration(): number {
            return this.offerPriceDetails.finalPriceDuration;
        },
        showInitialPrice(): boolean {
            return this.offerPriceDetails.initialPrice !== this.offerPriceDetails.finalPermanentPrice;
        },
        showTileOdrPrice() {
            return this.offerPriceDetails.cashbacks.length > 0;
        },
        cashbackType(): PriceDetailsCashbackType | undefined {
            return computeCashbackType(this.offerPriceDetails.cashbacks);
        },
        discountType(): PromotionType | undefined {
            return computeDiscountType(this.offerPriceDetails.discounts);
        },
        finalDiscountType(): PromotionType | undefined {
            return computeFinalDiscountType(this.offerPriceDetails.discounts, this.offerPriceDetails.cashbacks);
        },
    },
};
